export enum StompjsConnectionStatus {
	Connected = 'Connected',
	Disconnected = 'Disconnected',
	Reconnected = 'Reconnected'
}
